<template>
    <div>
        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <form @submit.prevent="submit">
                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Select Ads
                            </h3>

                            <p>
                                Select the ads to pay.
                            </p>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <buyable-select
                                        v-model="orderPayment.ads"
                                        :orders="orders.data"
                                        :disable-invoiced-ads="true"
                                        :disable-unpublished-ads="false"
                                ></buyable-select>
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="panel-separator">

                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Set Date
                            </h3>

                            <p>
                                Set the date of the invoices.
                            </p>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <date-form-group
                                        v-model="orderPayment.date"
                                        name="date"
                                        label="Date"
                                        help-text="The date of the invoices."
                                        :error="getError('date')"
                                        format="DD.MM.YYYY"
                                ></date-form-group>
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="panel-separator">

                <div class="row">
                    <div class="col-xs-offset-6 col-xs-18">
                        <button type="submit" class="btn btn-black" style="margin-bottom: 22px">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import moment from 'moment'
    import notify from '@/notify'
    import store from '@/store'
    import BuyableSelect from '@/components/BuyableSelect'
    import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
    import Errors from '@/mixins/Errors'
    import HelpText from '@/components/HelpText'
    import Load from '@/mixins/Load'
    import LoadingContainer from '@/components/Layout/LoadingContainer'

    export default {
        components: {BuyableSelect, DateFormGroup, HelpText, LoadingContainer},

        mixins: [Errors, Load],

        model: {
            prop: 'company',
            event: 'company-updated'
        },

        props: ['company'],

        data() {
            return {
                shared: store,
                orderPayment: {
                    date: moment().format('YYYY-MM-DD'),
                    ads: []
                },
                orders: {}
            }
        },

        watch: {
            'orderPayment.ads'(value) {
                let ids = value.map(ad => ad.order.id).filter((value, index, self) => self.indexOf(value) === index)

                if (ids.length) {
                    return this.orderPayment.headline = 'Vedr. ' + ids.map(id => 'HG' + id).join(', ')
                }

                this.orderPayment.headline = ''
            }
        },

        mounted() {
            this.load({
                orders: '/api/v1/orders?status=unpaid&company=' + this.company.data.id
            }, () => {
                this.orders.data = this.orders.data.map(order => {
                    order.ads.sort((a, b) => a.sort_key > b.sort_key ? 1 : -1)

                    return order
                })
            })
        },

        methods: {
            submit() {
                http.post('/api/v1/order-payments', this.orderPayment)
                    .then(() => {
                        notify.success('The order payments were saved')

                        this.$router.push('../orders')
                    })
                    .catch(this.catchValidationErrors)
            }
        }
    }
</script>
